import React, { useState, useEffect } from 'react';
import Logo from '../components/Logo';
import { useParams, useLocation } from 'react-router-dom';
import api from '../services/api';

export default function VendorRegister() {
  const { token: pathToken } = useParams();
  const { search } = useLocation();
  // Support both /vendor-register?token=xxx (current links) and the legacy
  // /vendor-register/:token path form.
  const token = pathToken || new URLSearchParams(search).get('token');
  const [valid, setValid] = useState(null);
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({});
  const [files, setFiles] = useState({});
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/vendors/register/${token}`)
      .then(r => { setValid(true); const cat = r.data?.data?.category; if (cat) { const days = ({ yarn: 45, fabric: 60 }[String(cat).toLowerCase()] ?? 90); setForm(p => ({ ...p, category: cat, payment_terms: `${days} days` })); } })
      .catch(() => setValid(false));
  }, [token]);

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      if (files.gst_photo) fd.append('gst_photo', files.gst_photo);
      if (files.cheque_photo) fd.append('cheque_photo', files.cheque_photo);
      await api.post(`/vendors/register/${token}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Submission failed');
    } finally { setSaving(false); }
  };

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, boxSizing: 'border-box', marginTop: 4 };
  const labelStyle = { fontSize: 12, color: '#555', fontWeight: 600, display: 'block', marginTop: 14 };
  const sectionStyle = { fontSize: 12, fontWeight: 700, color: '#3B3A8F', textTransform: 'uppercase', letterSpacing: 1, margin: '20px 0 10px', paddingBottom: 6, borderBottom: '2px solid #EEEDF8' };

  if (valid === null) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial' }}>Validating link...</div>;
  if (valid === false) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48 }}>❌</div>
        <h2 style={{ color: '#E22D2D' }}>Invalid or Expired Link</h2>
        <p style={{ color: '#888' }}>Please contact RSR International for a new invitation.</p>
      </div>
    </div>
  );

  if (done) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial', background: '#f0f2f8' }}>
      <div style={{ background: 'white', borderRadius: 12, padding: 40, textAlign: 'center', maxWidth: 480, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
        <div style={{ fontSize: 56 }}>🎉</div>
        <h2 style={{ color: '#3B3A8F', margin: '16px 0 8px' }}>Application Submitted!</h2>
        <p style={{ color: '#666', fontSize: 14 }}>Thank you for submitting your vendor application to RSR International. Our team will review your details and you will receive an email with your vendor code once approved.</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'transparent', fontFamily: 'inherit', padding: '30px 16px' }}>
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        {/* Header */}
        <div style={{ background: 'white', borderRadius: 12, padding: '20px 28px', marginBottom: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', display: 'flex', alignItems: 'center', gap: 16 }}>
          <Logo height={30} />
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#222' }}>Vendor Registration Form</div>
            <div style={{ fontSize: 12, color: '#888' }}>Please fill all details carefully</div>
          </div>
        </div>

        {error && <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 16px', borderRadius: 6, marginBottom: 16, fontSize: 13 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ background: 'white', borderRadius: 12, padding: 28, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>

            <div style={sectionStyle}>Business Information</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Business / Supplier Name *</label>
                <input style={inputStyle} required placeholder="Your business name" onChange={e => f('name', e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Category</label>
                <input style={{ ...inputStyle, background: '#f5f5f5', color: '#555', cursor: 'not-allowed' }} value={form.category ? form.category.charAt(0).toUpperCase() + form.category.slice(1) : '—'} readOnly />
              </div>
              <div>
                <label style={labelStyle}>Payment Terms</label>
                <input style={{ ...inputStyle, background: '#f5f5f5', color: '#166534', fontWeight: 600, cursor: 'not-allowed' }} value={form.payment_terms ? `🔒 ${form.payment_terms} (set by RSR)` : '—'} readOnly />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Business Address *</label>
                <input style={inputStyle} required placeholder="Full address" onChange={e => f('address', e.target.value)} />
              </div>
            </div>

            <div style={sectionStyle}>Owner / Contact Details</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label style={labelStyle}>Owner Name *</label>
                <input style={inputStyle} required placeholder="Proprietor / Owner name" onChange={e => f('owner_name', e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Email ID *</label>
                <input style={inputStyle} required type="email" placeholder="your@email.com" onChange={e => f('email', e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Phone Number *</label>
                <input style={inputStyle} required type="tel" placeholder="+91 XXXXX XXXXX" onChange={e => f('phone', e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Alternate Phone</label>
                <input style={inputStyle} type="tel" placeholder="+91 XXXXX XXXXX" onChange={e => f('alt_phone', e.target.value)} />
              </div>
            </div>

            <div style={sectionStyle}>GST & Tax Details</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label style={labelStyle}>GST Number *</label>
                <input style={inputStyle} required placeholder="27AAAAA0000A1Z5" maxLength={15} onChange={e => f('gstin', e.target.value.toUpperCase())} />
              </div>
              <div>
                <label style={labelStyle}>PAN Number *</label>
                <input style={inputStyle} required placeholder="AAAAA0000A" maxLength={10} onChange={e => f('pan', e.target.value.toUpperCase())} />
              </div>
              <div>
                <label style={labelStyle}>📷 Upload GST Certificate *</label>
                <input style={{ ...inputStyle, padding: '8px' }} required type="file" accept="image/*,application/pdf" onChange={e => setFiles(p => ({ ...p, gst_photo: e.target.files[0] }))} />
              </div>
              <div>
                <label style={labelStyle}>📷 Upload Cancelled Cheque *</label>
                <input style={{ ...inputStyle, padding: '8px' }} required type="file" accept="image/*,application/pdf" onChange={e => setFiles(p => ({ ...p, cheque_photo: e.target.files[0] }))} />
              </div>
            </div>

            <div style={sectionStyle}>Bank Details</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label style={labelStyle}>Account Holder Name *</label>
                <input style={inputStyle} required placeholder="As per bank records" onChange={e => f('bank_account_name', e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Account Number *</label>
                <input style={inputStyle} required placeholder="Account number" onChange={e => f('bank_account_no', e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Bank Name *</label>
                <input style={inputStyle} required placeholder="e.g. HDFC Bank" onChange={e => f('bank_name', e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Branch Name</label>
                <input style={inputStyle} placeholder="Branch name" onChange={e => f('bank_branch', e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>IFSC Code *</label>
                <input style={inputStyle} required placeholder="HDFC0001234" maxLength={11} onChange={e => f('ifsc', e.target.value.toUpperCase())} />
              </div>
              <div>
                <label style={labelStyle}>Account Type</label>
                <select style={inputStyle} onChange={e => f('bank_account_type', e.target.value)}>
                  <option value="current">Current</option>
                  <option value="savings">Savings</option>
                </select>
              </div>
            </div>

            <div style={{ marginTop: 20 }}>
              <label style={labelStyle}>Additional Notes</label>
              <textarea style={{ ...inputStyle, height: 80, resize: 'vertical' }} placeholder="Any additional information..." onChange={e => f('notes', e.target.value)} />
            </div>

            <button type="submit" disabled={saving} style={{ marginTop: 24, width: '100%', padding: '14px', background: '#3B3A8F', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
              {saving ? 'Submitting...' : '✅ Submit Vendor Application'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
